<template>

  <b-row align-h="center" class="d-flex flex-column flex-grow-1 py-3" style="height: 100%">

    <!-- <b-col v-if="generateWaiver == '1' && onlineWaiver == '0' ">
      <p> Click the button below to sign Gamebay Waiver </p>
      <b-button @click="clickedGamebay()" variant="info" style="color:white;margin-bottom:7%;">Gamebay Waiver</b-button>
    </b-col> -->

    <b-col class="text-center">

      <router-view></router-view>
    </b-col>

  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import { SELECTED_RESERVATION } from '@/store/state';
import { FETCH_BOOKER, FETCH_RESERVATION } from '@/store/actions';
import { formatTime, getDisplayName, validateTimestamp } from '@/utils';
import ReservationSelect from '@/components/ReservationSelect';
import BookerSelect from '@/components/BookerSelect';
import NavigationFooter from '@/components/NavigationFooter.vue';
// import Gamebay from '@/views/Gamebay.vue';

import axios from 'axios';
import { validateBeforeRouteLeave } from '@/utils/mixins/validateBeforeRouteLeave';

export default {

  data(){
      return{
        generateWaiver: '0',
        onlineWaiver: '',
    }
  },
  components: {
    ReservationSelect,
    BookerSelect,
    NavigationFooter,
    // Gamebay,
    // generateWaiver: '',
  },
  computed: {
    ...mapState([
      SELECTED_RESERVATION
    ]),
  },
  async created () {

    // console.log(this.$route.params);
    console.log('deployed v1.2');

    // const { reservationId } = this.$route.params; // NOTE: captured from the params in router/index

    var reservationId = this.$route.fullPath.slice(3);
    console.log('reservation id print '+reservationId);

    // console.log(process.env.VUE_APP_PERSON_SURVEY_ANSWER);

    
      // axios.get(process.env.VUE_APP_PERSON_SURVEY_ANSWER,{

      // })
      // .then(response => 
      // {
      //   console.log('found reservation detail');
      //   console.log(response);

      // })
      // .catch(function (error) {
      //   console.log(error);
      // });

     
    if(reservationId == 'atlgamebaywaiver'){
      console.log('load /gamebay waiver');
      // this.generateWaiver = '1';
      return this.$router.push('/gamebay');
      // return this.$router.push('/gamebay');
    }

    /** this function will make sure the url link for online is correct **/
    // var urlOrderId = this.$route.fullPath.slice(3);

    // if(process.env.VUE_APP_ONLINE_WAIVER == 1){

    //   console.log('ONLINE WAIVER , make sure the url is correct 1.1');

    //   console.log(process.env.VUE_APP_RESERVATIONS+'/xola_order_id/'+urlOrderId);

    //   axios.get(process.env.VUE_APP_RESERVATIONS+'/xola_order_id/'+urlOrderId,{

    //   })
    //   .then(response => 
    //   {
    //     console.log('found reservation detail');
    //     // console.log(response);
    //     this.xola_order_id = response.data.xola_order_id;
    //     console.log(this.xola_order_id);

    //   })
    //   .catch(function (error) {

    //     console.log('incorrect inside endpoint');

    //     console.log(error);

    //   });
    // }
    // else{
    //   console.log('IN SPACE WAIVER');
    // }
    /** end of online waiver link check **/

    this.onlineWaiver = process.env.VUE_APP_ONLINE_WAIVER;

    if(process.env.VUE_APP_ONLINE_WAIVER == 1){
      this.generateWaiver = '1';
    }

    // console.log('I AM TALKING');

    if (reservationId) {
      const reservation = await this.$store.dispatch(FETCH_RESERVATION, {id: reservationId});
      if (reservation) {
        try {
          const booker = await this.$store.dispatch(FETCH_BOOKER, { id: reservation?.booker_id })
          if (booker) this.$router.push({ name: 'Confirm' })
        } catch (err) {
          console.log("no booker");
          console.error(err)
        }
      }
      else{

        if(process.env.VUE_APP_ONLINE_WAIVER == 1){
          
          // maybe it's a hashed timestamp?
          try{
            console.log("yeah so I think I'mma try validating this as a timestamp");
            const auth = await axios.get(process.env.VUE_APP_TIMESTAMP_VALIDATOR + '/' + reservationId);
            this.$router.push('/find');
          }
          catch(err){
            console.log("not a timestamp, aw");
            console.warn(err);
            this.$router.replace({ name: 'FindReservation' })
            this.$router.push('/link');
          }

        }

      }
    }
    else { 
      // no reservation in id  
      if(process.env.VUE_APP_ONLINE_WAIVER == 1){
          this.$router.push('/link');
        }
        else{
      this.$router.push('/find');
        }
    }
    console.log(process.env.VUE_APP_SURVEY_BLACKLIST)
    console.log(process.env.VUE_APP_SURVEY_CUSTOM_SORT)
  },
  methods: {
    getDisplayName, // make accesible to template
    formatTime,
  },
  computed:{
    // clickedGamebay: function(){
    //   console.log('clicked on game bay waiver');
    //   return this.$router.push('/gamebay');
    // }
  },

  // beforeEnter(to, from){
  //   // this.mqttConnected.end();
  //   console.log('from was '+from);
  //   console.log('closed mqtt connection');
  //   // next();
  // },

  mounted: function(){

    // console.log('generate value from env was '+process.env.VUE_APP_ONLINE_WAIVER);

    // console.log(this.$router.app._route.fullPath);

    

  },

}
</script>

<style scoped>

</style>

